import { createContext } from 'react';

const productosXactivoContext = createContext();

export default productosXactivoContext;